import { PartyPopper } from 'lucide-react';
import { type z } from 'zod';

import { cx } from '@/lib/cx';
import { Carimbo } from '@/ui/components/carimbo';
import { Kpi } from '@/ui/components/kpi';
import { type resumoPendenciasSchema } from '@fiscoai/contracts';

import { type Prioridade } from './api';

type Resumo = z.infer<typeof resumoPendenciasSchema>;

const PRIORIDADES: { valor: Prioridade; rotulo: string }[] = [
  { valor: 'ALTA', rotulo: 'Prioridade alta' },
  { valor: 'MEDIA', rotulo: 'Prioridade média' },
  { valor: 'BAIXA', rotulo: 'Prioridade baixa' },
];

interface Props {
  resumo: Resumo | undefined;
  ativa: Prioridade | undefined;
  aoAlternar: (prioridade: Prioridade | undefined) => void;
}

/** Contadores por prioridade que também filtram (clicar de novo tira o filtro). */
export function IndicadoresPendencias({ resumo, ativa, aoAlternar }: Props) {
  return (
    <>
      {PRIORIDADES.map((p) => (
        <button
          key={p.valor}
          type="button"
          aria-pressed={ativa === p.valor}
          onClick={() => {
            aoAlternar(ativa === p.valor ? undefined : p.valor);
          }}
          className="rounded-cartao text-left transition-transform duration-[var(--duracao-rapida)] focus-visible:outline-none focus-visible:ring-3 focus-visible:ring-marca-suave active:translate-y-px"
        >
          <Kpi
            rotulo={p.rotulo}
            valor={resumo ? resumo.porPrioridade[p.valor] : null}
            destaque={ativa === p.valor}
            className={cx(
              'h-full',
              p.valor === 'ALTA' && resumo?.porPrioridade.ALTA && 'border-perigo/40',
            )}
          />
        </button>
      ))}
      <Kpi rotulo="Total no período" valor={resumo ? resumo.total : null} />
    </>
  );
}

/** Nenhuma pendência alta = o mês pode seguir para a contabilidade. Merece o carimbo. */
export function MesPronto() {
  return (
    <div className="flex animate-surgir items-center gap-4 rounded-cartao border border-sucesso/30 bg-sucesso-suave px-5 py-4">
      <PartyPopper className="size-6 shrink-0 text-sucesso" aria-hidden />
      <div className="grid flex-1 gap-0.5">
        <span className="font-semibold">Mês pronto para a contabilidade</span>
        <span className="text-sm text-texto-suave">
          Nenhuma pendência de prioridade alta. O que sobrou é informativo.
        </span>
      </div>
      <Carimbo tom="sucesso" className="text-sm">
        Pronto
      </Carimbo>
    </div>
  );
}
